import styled from '@emotion/styled';
import { IconButton, SxProps, Tooltip } from '@mui/material';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { toggleFullWidth } from '@/redux/slices/authSlice';
import { selectAuthLoading, selectUserFullWidthMode } from '@/redux/selectors/authSelectors';
import { selectCurrentTableKey } from '@/redux/selectors/dataTableSelectors';
import PolarisIcon from '@/components/_common/PolarisIcon';

interface ToggleFullWidthProps {
  color?: 'default' | 'primary';
  className?: string;
  sx?: SxProps;
}

export const UIWidth = {
  FULL: true,
  COMPACT: false,
  COMPACT_NO_ANIMATE: null
};

const ToggleFullWidth = ({ color = 'default', className, sx }: ToggleFullWidthProps) => {
  const dispatch = useAppDispatch();
  const tableKey = useAppSelector(selectCurrentTableKey);
  const fullWidthMode = useAppSelector(selectUserFullWidthMode);
  const isFullWidth = fullWidthMode && tableKey && fullWidthMode.includes(tableKey);
  const loading = useAppSelector(selectAuthLoading);

  const handleToggleFullWidth = () => {
    dispatch(toggleFullWidth(tableKey!));
  };

  return (
    <Wrapper>
      <Tooltip title="Toggle full width table">
        <span>
          <IconButton
            disabled={loading}
            color={color}
            onClick={handleToggleFullWidth}
            size="small"
            sx={{
              ...sx,
              padding: '5px'
            }}
          >
            <PolarisIcon className={className} icon={isFullWidth ? 'condense' : 'expand'} height={20} />
          </IconButton>
        </span>
      </Tooltip>
    </Wrapper>
  );
};

export default ToggleFullWidth;

const Wrapper = styled.div`
  @media (max-width: 2199px) {
    display: none;
  }
`;
